var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 875,
    viewBox: "0 0 205 875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_bi_23051_124130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.502 747.142C134.594 748.006 133.724 748.912 132.896 749.859L133.81 745.502C134.355 746.07 134.919 746.618 135.502 747.142ZM83.6964 780.522L83.697 780.522C79.7717 799.785 91.1581 818.419 109.214 822.206C121.246 824.73 133.215 820.026 141.089 810.921C145.299 813.719 150.102 815.78 155.351 816.881C177.49 821.525 199.201 807.342 203.845 785.204C207.698 766.833 198.588 748.757 182.726 740.483C186.251 735.766 188.876 730.095 190.203 723.768C193.915 706.069 186.263 688.981 172.617 682.04C173.076 680.661 173.461 679.239 173.768 677.779C176.997 662.383 170.429 647.354 158.472 639.947C161.42 636.467 163.953 632.505 165.945 628.114C173.637 611.152 171.183 592.328 161.133 579.158C164.068 575.502 166.621 571.384 168.674 566.857C176.7 549.16 174.996 529.84 165.779 516.22C177.761 508.697 187.743 497.691 194.024 483.842C209.36 450.026 197.407 410.783 167.468 390.856C171.075 382.328 171.319 372.146 167.341 362.606C166.806 361.324 166.21 360.088 165.557 358.9C178.176 349.808 182.808 331.311 175.755 314.396C174.723 311.922 173.491 309.601 172.092 307.451C185.006 296.296 189.938 277.706 183.013 261.099C177.663 248.269 166.494 239.634 153.846 236.98C154.996 235.366 156.064 233.661 157.042 231.868C165.053 217.174 164.81 200.471 157.755 188.189C168.523 182.482 177.792 173.658 184.062 162.158C201.072 130.959 189.569 91.8783 158.37 74.8688C127.172 57.8594 88.091 69.3621 71.0816 100.561C54.3928 131.171 65.1512 169.369 95.03 186.864C92.961 189.336 91.0923 192.064 89.4747 195.031C82.8799 207.127 81.8783 220.584 85.6657 231.817C82.9749 232.171 80.2974 232.88 77.6887 233.967C60.8096 241.006 53.1805 261.263 60.5789 279.292L60.5763 279.293L103.33 381.824C83.8985 388.021 67.0653 402.106 57.9781 422.143C41.2609 459.004 56.9693 502.315 93.0538 520.025C90.8672 523.064 88.9345 526.384 87.3133 529.958C79.173 547.908 81.0421 567.527 90.608 581.175C88.2737 584.205 86.2413 587.561 84.5842 591.215C73.7111 615.19 83.11 642.886 105.577 653.075C107.412 653.907 109.277 654.596 111.161 655.148C109.854 657.832 108.842 660.725 108.181 663.79L108.18 663.789L108.161 663.884L108.133 664.013L108.107 664.141L83.7422 780.303L83.6964 780.522Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_bi_23051_124130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.348 129.262L104.334 129.228L104.335 129.272L104.348 129.262ZM58.6731 81.6336C58.6744 81.7127 58.6759 81.7917 58.6776 81.8706L60.6797 208.716C60.68 208.774 60.6806 208.833 60.6812 208.891C60.6817 208.94 60.6824 208.988 60.6831 209.037L60.6839 209.094C60.929 224.619 69.778 237.855 82.3005 243.703C69.7802 256.692 66.2018 277.391 74.8321 295.649C76.5016 299.181 78.5317 302.418 80.8505 305.331C71.745 318.772 70.2271 337.91 78.4315 355.267C82.0046 362.826 87.0092 369.175 92.8561 374.057C86.7705 375.176 80.7286 377.095 74.8699 379.864C38.5376 397.038 23.0065 440.413 40.1802 476.745C47.7412 492.741 60.3809 504.705 75.2623 511.621L40.1538 599.706L40.1571 599.708C33.227 617.383 40.9698 636.999 57.5197 643.595C61.1612 645.046 64.9267 645.747 68.6614 645.77C69.341 647.497 70.1429 649.202 71.0701 650.873C74.023 656.197 77.9377 660.623 82.4385 664.031C77.9501 675.387 78.7111 689.42 85.6363 701.905C86.5717 703.591 87.5906 705.197 88.6829 706.719C87.3192 707.353 85.9683 708.039 84.6328 708.78C54.4077 725.545 43.4961 763.638 60.2611 793.863C77.0261 824.088 115.119 835 145.344 818.235C175.569 801.47 186.481 763.377 169.716 733.152C164.731 724.165 157.861 716.886 149.873 711.534C158.77 699.341 159.778 681.253 151.095 665.597C147.783 659.627 143.425 654.665 138.465 650.871C140.575 646.151 141.724 640.969 141.83 635.655C149.676 631.401 156.134 624.48 159.697 615.541C166.187 599.258 161.098 581.227 148.349 570.56C149.677 568.445 150.84 566.167 151.806 563.743C158.417 547.157 153.62 529.209 141.186 520.548C141.805 519.379 142.368 518.164 142.87 516.905C144.189 513.595 144.992 510.216 145.318 506.864C175.654 487.416 187.561 448.001 171.751 414.554C164.716 399.67 153.284 388.278 139.741 381.194C160.905 370.63 168.699 342.578 157.116 318.074C155.048 313.698 152.499 309.727 149.585 306.212C159.17 293.23 161.27 274.858 153.517 258.456C147.441 245.602 136.589 236.656 124.422 232.985C129.672 226.199 132.767 217.456 132.617 207.959C132.594 206.45 132.488 204.962 132.307 203.501C148.64 199.42 160.711 182.678 160.398 162.844C160.352 159.942 160.044 157.114 159.498 154.39C176.953 148.351 189.361 131.637 189.054 112.164C188.671 87.9011 168.691 68.5423 144.428 68.9253C139.183 69.0081 134.167 70.0066 129.53 71.7663C125.553 54.8423 111.078 42.4163 94.0341 42.6854C74.1702 42.9989 58.3386 60.4366 58.6731 81.6336ZM93.8995 574.051L93.8846 574.067L93.8944 574.043L93.8995 574.051Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_23051_124130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9303 48.2928V184.871V185.13H20.9311C21.0146 199.6 28.1009 212.298 38.7559 219.56C29.1261 233.221 26.9897 252.154 34.7525 269.271C36.4819 273.085 38.6028 276.588 41.0387 279.749C31.0548 293.995 29.1043 314.474 37.601 333.209C39.2935 336.941 41.3111 340.407 43.5939 343.579C5.92717 362.065 -10.4702 407.274 6.9799 445.751C17.6382 469.253 38.5049 484.91 61.957 489.855L18.3011 594.55L18.2652 594.636L18.2296 594.721L18.1761 594.85L18.1766 594.85C12.8964 607.72 14.9529 621.679 22.4169 631.567C22.4977 639.772 24.5738 648.181 28.8463 656.018C30.8506 659.694 33.2226 663.032 35.8837 666.006C26.971 680.946 26.527 701.512 36.3743 719.574C38.3358 723.172 40.602 726.481 43.1112 729.477C6.90101 750.675 -6.13803 796.964 14.0858 834.059C34.6971 871.864 82.0531 885.802 119.858 865.191C157.664 844.58 171.602 797.224 150.991 759.419C143.392 745.481 132.159 734.788 119.109 727.873C127.662 712.989 127.958 692.745 118.249 674.937C115.766 670.382 112.794 666.291 109.459 662.71C114.073 655.643 116.701 647.312 117.099 638.65C129.653 635.516 140.617 626.694 145.979 613.834C153.207 596.499 148.06 577.095 134.581 565.452C136.04 563.208 137.325 560.788 138.401 558.207C145.764 540.55 140.928 521.24 127.754 511.751C128.437 510.509 129.061 509.216 129.62 507.875C134.505 496.16 133.291 483.517 127.436 473.849C154.098 452.012 163.897 414.223 148.988 381.348C142.432 366.892 132.013 355.403 119.505 347.551C129.126 333.333 130.905 313.166 122.528 294.693C120.385 289.969 117.721 285.671 114.658 281.855C125.147 268.108 127.708 248.46 119.679 230.756C114.102 218.458 104.453 209.387 93.2978 204.602C96.3047 198.745 98.0144 192.021 98.0144 184.871C98.0144 183.257 97.9272 181.665 97.7577 180.099C115.323 176.001 128.538 158.27 128.538 137.017C128.538 134.137 128.295 131.322 127.832 128.597C156.673 121.89 178.162 96.0269 178.162 65.1446C178.162 29.1662 148.996 0 113.017 0C99.4139 0 86.7846 4.16947 76.3373 11.3002C71.2433 8.65067 65.5205 7.16406 59.4723 7.16406C38.267 7.16406 21.0615 25.4384 20.9311 48.0341H20.9303V48.2928ZM76.1891 568.273L76.1743 568.288L76.1842 568.265L76.1891 568.273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_23051_124130",
    x: 26.3081,
    y: 42.0247,
    width: 203.4,
    height: 805.841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.4916
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23051_124130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23051_124130",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1532
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_23051_124130"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_23051_124130",
    x: 8.84545,
    y: 18.3411,
    width: 204.553,
    height: 832.099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.1693
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23051_124130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23051_124130",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8655
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_23051_124130"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_23051_124130",
    x: -26.0781,
    y: -26.0781,
    width: 230.318,
    height: 926.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.039
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23051_124130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23051_124130",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.642
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_23051_124130"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.a7fe8503d481995cdbeded1af56a9a75.svg";
export { ForwardRef as ReactComponent };